// allow this function to be called from other places and files, because its bound in the window
window.autoFillAddress = autoFillAddress;

/**
 * autoFillAddress()
 * @param postcodeValue e.g. 3645LA
 * @param numberValue e.g. 15
 * Fill the address based on postcode and housenumber
 */
async function autoFillAddress( postcodeValue, numberValue ) {
    const apiUrl = `/wp-json/postcode/v1/api/?postcodeValue=${postcodeValue}&numberValue=${numberValue}`;

    try {
        const response = await fetch( apiUrl, {
            method: 'GET', // HTTP method as specified in your register_rest_route
            headers: {
                'Content-Type': 'application/json', // Ensure the request content type is correct
            },
        });

        if ( !response.ok && response.status != 404 ) {
            throw new Error( `HTTP error! Status: ${response.status}` );
        }

        const data = await response.json(); // Parse the JSON response

        if ( data.street !== undefined ) {
            return data; // Return the data
        } else {
            console.warn( 'Address data is incomplete or not found.' );
            return null;
        }
    } catch ( error ) {
        console.error( 'Error calling the API:', error ); // Handle any errors
        return null; // Return null in case of errors
    }
}
